import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { ScenarioDefinition } from "@reporting/rp-types/definition";

const PAGE_SIZE = 500;

export class ScenarioGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 2,
			content: [{
				action: 'delete',
				title: msg('Delete'),
				icon: 'trash',
				color: ColorTypes.Red
			}, {
				action: 'duplicate',
				title: msg('Duplicate'),
				icon: 'copy',
				color: ColorTypes.Yellow
			}],
			filter: false,
			sorting: false,
		}, {
			data: 'idz',
			t: 'n',
			hidden: true,
			e: false,
		}, {
			data: 'a_b',
			header: msg('Scenario'),
			t: 't',
			e: true,
			w: 100
		}, {
			data: 'description',
			header: msg('Description'),
			t: 't',
			e: true,
			w: 300
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		const scenarios = await rp.ms('definition').get<ScenarioDefinition[]>(`scenarios`, this.createRequestParams(filters, {
			fields: ['idz', 'a_b', 'description'],
			order: [['a_b', 'asc']],
			count: PAGE_SIZE
		}));
		return scenarios.map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: PAGE_SIZE,
			refreshAfterSave: true,
			showEmptyRow: true,
			rowMenu: {
				addRows: true,
				deleteRows: true,
			},
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({_state: row.state, _index: row.index}, row.data));
		await rp.ms('definition').post('scenarios', data);
	}

}
